module.exports = __webpack_public_path__ + "img/3.47dacbb2.png";